import type { SyntheticEvent } from 'react';

/** A decorative picture that is not there (yet) takes no room. */
const hideBroken = (e: SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.hidden = true;
};

/**
 * The sizes of the illustration set, defined once: `sm` inside a card (a compact state), `lg` for a full-area state.
 * Phones shrink both in CSS (feedback.css), so no page sets a size of its own.
 */
const SIZE = { sm: 72, lg: 200 } as const;

/** Decorative illustration (transparent background, works on any surface, lazy, hidden from screen readers). */
export function Illustration({ src, size = 'lg', className = '' }: { src: string; size?: keyof typeof SIZE; className?: string }) {
  const px = SIZE[size];
  return <img className={`illustration illustration-${size} ${className}`} src={src} alt="" aria-hidden="true" width={px} height={px} loading="lazy" decoding="async" onError={hideBroken} />;
}
